/**
 * @generated SignedSource<<64eca56d7b403aaa22c5fddf6b1bde15>>
 * @relayHash 1861dde5f9aa491e249c14ee06278aec
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1861dde5f9aa491e249c14ee06278aec

import { ConcreteRequest } from 'relay-runtime';
export type AttachmentsChangedReason = "UPLOAD_SESSION_REVERTED" | "UPLOAD_STATUS_CHANGED";
export type DocumentType = "AUDIO" | "PDF" | "PHOTO" | "VIDEO";
export type FileUploadSource = "DOC2_U" | "PATIENT" | "SOFIA";
export type FileUploadStatus = "ERROR" | "HYPERLINK_PROCESSING_FAILED" | "JAVA_SCRIPT_PROCESSING_FAILED" | "MALICIOUS" | "NO_THREAT_FOUND" | "SCAN_TIMEOUT" | "UPLOADED";
export type usePatientAttachmentSubscription$variables = {
  appointmentId: string;
};
export type usePatientAttachmentSubscription$data = {
  readonly attachmentsChanged: {
    readonly attachments: ReadonlyArray<{
      readonly attachmentType: DocumentType;
      readonly fileName: string;
      readonly id: string;
      readonly thumbnailUrl: string | null;
      readonly uploadDate: string;
      readonly uploadSource: FileUploadSource;
      readonly uploadStatus: FileUploadStatus | null;
      readonly url: string;
    }>;
    readonly reason: AttachmentsChangedReason;
  };
};
export type usePatientAttachmentSubscription = {
  response: usePatientAttachmentSubscription$data;
  variables: usePatientAttachmentSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appointmentId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "appointmentId",
        "variableName": "appointmentId"
      }
    ],
    "concreteType": "AttachmentsChange",
    "kind": "LinkedField",
    "name": "attachmentsChanged",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AppointmentAttachment",
        "kind": "LinkedField",
        "name": "attachments",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thumbnailUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uploadDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "attachmentType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fileName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uploadStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uploadSource",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reason",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usePatientAttachmentSubscription",
    "selections": (v1/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "usePatientAttachmentSubscription",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "1861dde5f9aa491e249c14ee06278aec",
    "metadata": {},
    "name": "usePatientAttachmentSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "ab1d0899c5ec93593c45f2cd6c5f3b13";

export default node;
